import { render } from "./ImprestCashierPageCompleted.vue?vue&type=template&id=b8021bde"
import script from "./ImprestCashierPageCompleted.vue?vue&type=script&lang=js"
export * from "./ImprestCashierPageCompleted.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__